import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RefreshService {
  private refreshBehaviorSubject:BehaviorSubject<string> = new BehaviorSubject("");

  constructor() { }


  get refresh(): Observable<string> {
    return this.refreshBehaviorSubject.asObservable()
  }

  set refresh(data:string) {
    this.refreshBehaviorSubject.next(data);
  }


}
